<template>
  <el-dialog
    class="project-search-radish"
    title="人才搜寻反馈"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="calc(100vw - 200px)"
  >
    <template v-if="isEditing">
      <div class="flex mb10">
        <div class="half">
          <p class="flex">
            <span class="keep-all dialog-common-title w196">符合要求人选（人数）：</span>
            <!-- {{ radishProjectDetail.已搜寻 }} -->
            <el-input v-model="countDetail.已搜寻" class="mr10" style="width:60px" size="mini"></el-input>
          </p>
        </div>
        <div class="half">
          <p class="flex">
            <span class="keep-all dialog-common-title">已沟通人选（人数）：</span>
            <!-- {{ radishProjectDetail.已沟通 }} -->
            <el-input v-model="countDetail.已沟通" class="mr10" style="width:60px" size="mini"></el-input>
          </p>
        </div>
      </div>
      <div class="flex mb10">
        <span class="keep-all dialog-common-title w196">搜索行业：</span>
        <el-input v-model="countDetail.行业" class="flex-grow" size="mini"></el-input>
        <!-- <div class="flex-grow" style="padding-top:2px">{{ (radishProjectDetail.行业 || []).join('、') }}</div> -->
      </div>
      <div class="flex mb10">
        <span class="keep-all dialog-common-title w196">搜索公司：</span>
        <el-input v-model="countDetail.公司" class="flex-grow" size="mini"></el-input>
        <!-- <div class="flex-grow" style="padding-top:2px">{{ (radishProjectDetail.公司 || []).join('、') }}</div> -->
      </div>
      <div class="flex mb10">
        <span class="keep-all dialog-common-title w196">人选不考虑原因：</span>
        <el-input
          v-model="report.不考虑的原因"
          class="flex-grow"
          type="textarea"
          size="mini"
          :rows="3"
          placeholder="项目逾期没有推荐人选，请填写此项目人选不考虑原因，以便客户经理给客户反馈"
        >
        </el-input>
      </div>
      <div class="flex mb10">
        <span class="keep-all dialog-common-title w196">市场情况及遇到的问题：</span>
        <el-input
          v-model="report.市场情况"
          class="flex-grow"
          type="textarea"
          size="mini"
          :rows="3"
          placeholder="项目逾期没有推荐人选，请填写此项目市场情况说明，以便客户经理给客户反馈"
        >
        </el-input>
      </div>
      <div class="flex mb10">
        <span class="keep-all dialog-common-title w196">阿尔法建议：</span>
        <el-input
          v-model="report.阿尔法建议"
          class="flex-grow"
          type="textarea"
          size="mini"
          :rows="3"
          placeholder="阿尔法建议"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="isEditing = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
      </span>
    </template>
    <template v-else>
      <div class="mb10">
        <div class="flex mb10 align-center">
          <p class="keep-all dialog-common-title">项目小结</p>
          <!-- <span class="btn_default" @click="copyMode=!copyMode">{{copyMode?'详情模式':'复制模式'}}</span> -->
          <!-- <span class="btn_default" @click="copy">复制文字</span> -->
          <el-tooltip
            effect="dark"
            content="点击可将项目小结文字版复制到剪贴板，可微信直接发送给客户"
            placement="right"
          >
            <span class="btn_default" @click="copy">复制文字</span>
          </el-tooltip>
        </div>
        <!-- <div v-if="copyMode" class="project-summary">
          <p>{{project.客户公司}}--{{project.项目名称}}【项目反馈】</p>
          <br />
          <p>
            从{{ dateFormat(project.startTime || project.createdAt, 'yyyy-mm-dd') }}项目启动至今，市场上符合要求人选{{
              (report.人才推荐统计 && report.人才推荐统计.已搜寻) || radishProjectDetail.已搜寻
            }}人，已沟通{{ (report.人才推荐统计 && report.人才推荐统计.已沟通) || radishProjectDetail.已沟通 }}位；
          </p>
          <br />
          <p>
            我们搜索了{{
              (report.人才推荐统计 && report.人才推荐统计.行业) || (radishProjectDetail.行业 || []).join('、')
            }}等行业；共计{{
              (report.人才推荐统计 && report.人才推荐统计.公司 && report.人才推荐统计.公司.split('、').length) ||
                (radishProjectDetail.公司 || []).length
            }}家公司；
          </p>
          <br />
          <p>人选不考虑的原因：</p>
          <p class="word-wrap">{{ report.不考虑的原因 }}</p>
          <br />
          <p>市场情况及遇到的问题：</p>
          <p class="word-wrap">{{ report.市场情况 }}</p>
          <br />
          <p>我们的建议：</p>
          <p class="word-wrap">{{ report.阿尔法建议 }}</p>
          <span class="project-summary-btn" @click="toEdit">编辑</span>
        </div> -->
        <!-- <div v-else class="project-summary"> -->
        <div class="project-summary">
          <span class="project-summary-btn" @click="toEdit">编辑</span>
          <div class="flex mb10">
            <div class="half">
              <p class="flex align-center">
                <span class="keep-all w155">符合要求人选（人数）：</span>
                <span style="line-height: 24px;">{{
                  (report.人才推荐统计 && report.人才推荐统计.已搜寻) || radishProjectDetail.已搜寻
                }}</span>
              </p>
            </div>
            <div class="half">
              <p class="flex align-center">
                <span class="keep-all w155 flex-none">已沟通人选（人数）：</span>
                <span style="line-height: 24px;">{{
                  (report.人才推荐统计 && report.人才推荐统计.已沟通) || radishProjectDetail.已沟通
                }}</span>
              </p>
            </div>
          </div>
          <div class="flex mb10">
            <span class="keep-all w155">搜索行业：</span>
            <span style="line-height: 24px;">{{
              (report.人才推荐统计 && report.人才推荐统计.行业) || (radishProjectDetail.行业 || []).join('、')
            }}</span>
          </div>
          <div class="flex mb10">
            <span class="keep-all w155">搜索公司：</span>
            <span style="line-height: 24px;">{{
              (report.人才推荐统计 && report.人才推荐统计.公司) || (radishProjectDetail.公司 || []).join('、')
            }}</span>
          </div>
          <div class="flex mb10">
            <span class="keep-all w155">人选不考虑原因：</span>
            <p class="word-wrap" style="line-height: 24px;">{{ report.不考虑的原因 }}</p>
          </div>
          <div class="flex mb10">
            <span class="keep-all w155">市场情况及遇到的问题：</span>
            <p class="word-wrap" style="line-height: 24px;">{{ report.市场情况 }}</p>
          </div>
          <div class="flex mb10">
            <span class="keep-all w155">阿尔法建议：</span>
            <p class="word-wrap" style="line-height: 24px;">{{ report.阿尔法建议 }}</p>
          </div>
        </div>
      </div>
      <div class="flex mb10 align-center">
        <span class="keep-all dialog-common-title">生成详细版的报告发给客户：</span>
        <!-- <a
          :href="`#/project/${project.pid || project._id}/report`"
          class="btn_default"
          target="_blank"
          style="margin: 0;"
          >生成报告</a
        > -->
        <span class="btn_default" style="margin: 0;" @click="getReport">生成报告</span>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import project_notify from '../../../radish/src/constant/project_notify'

const dateFormat = require('dateformat')

export default {
  data() {
    return {
      dialogVisible: false,
      isEditing: true,
      project: {},
      step: null,
      projectDetail: [],
      radishProjectDetail: {},
      report: {},
      summary: '',
      countDetail: {},
      updatedBy: [],
      copyMode: true,
    }
  },
  methods: {
    async getReport() {
      const { project } = this
      const loading = this.$loading({
        lock: true,
        text: '正在获取项目进展报告，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const res = await app.service('project').getProjectReport({
          pid: project.pid || project._id,
        })
        if (res && res.status === 'success' && res.data) {
          app.root.$refs.ProjectReportEditor.open({
            url: res.data.url,
            md5: res.data.md5,
            documentType: res.data && res.data.documentType,
            fileType: res.data && res.data.fileType,
            originalname: res.data && res.data.originalname,
          })
        } else this.$message.error(res.msg)
      } catch (e) {
        console.error(e)
        this.$message.error(`生成项目搜索进度报告出错`)
      }
      loading.close()
    },
    // async confirm() {
    //   try {
    //     const fields = ['不考虑的原因', '市场情况', '阿尔法建议']
    //     fields.forEach(v => {})
    //     if (this.project._id) {
    //       await window.app.service('project').modify({
    //         id: this.project._id,
    //         param: this.report,
    //       })
    //       this.$message({ type: 'success', message: `修改成功` })
    //     }
    //     Object.assign(this.project, this.report)
    //     this.dialogVisible = false
    //   } catch (e) {
    //     this.$message.error(`update project :${e.message}`)
    //   }
    // },
    copy() {
      const oTextarea = document.createElement('textarea')
      const { project, report, radishProjectDetail } = this
      oTextarea.value = `${project.客户公司}--${project.项目名称}【项目反馈】
从${dateFormat(
        project.startTime || project.createdAt,
        'yyyy-mm-dd',
      )}项目启动至今，市场上符合要求人选${(report.人才推荐统计 && report.人才推荐统计.已搜寻) ||
        radishProjectDetail.已搜寻}，已沟通${(report.人才推荐统计 && report.人才推荐统计.已沟通) ||
        radishProjectDetail.已沟通}位；

我们搜索了${(report.人才推荐统计 && report.人才推荐统计.行业) ||
        (radishProjectDetail.行业 || []).join('、')}等行业；共计${(report.人才推荐统计 &&
        report.人才推荐统计.公司 &&
        report.人才推荐统计.公司.split('、').length) ||
        (radishProjectDetail.公司 || []).length}家公司；

人选不考虑的原因：
${report.不考虑的原因}

市场情况及遇到的问题：
${report.市场情况}

我们的建议：
${report.阿尔法建议}`
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand('Copy')
      document.body.removeChild(oTextarea)
      this.$message.success('复制成功')
    },
    async open(project, step) {
      this.project = project
      this.dialogVisible = true
      this.isEditing = false
      this.copyMode = false
      this.report = {}
      await this.countRadishes()
      await this.loadProjectReport()
    },
    toEdit() {
      this.isEditing = true
      this.countDetail = {
        已搜寻: this.radishProjectDetail.已搜寻,
        已沟通: this.radishProjectDetail.已沟通,
        行业: this.radishProjectDetail.行业.join('、'),
        公司: this.radishProjectDetail.公司.join('、'),
      }
    },
    async countRadishes() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length
      const res = await app.service('radish').findByIds({ ids: radishProject.map(item => item.rid) })
      if (res.status === 'success') {
        const radishes = res.data
        searchRadishDetail.行业 = radishes.map(val => val.行业).filter(val => val)
        searchRadishDetail.公司 = radishes.map(val => val.公司).filter(val => val)
      } else this.$message.error(res.msg)
      const setObjIndustry = new Set(searchRadishDetail.行业)
      const setObjCompany = new Set(searchRadishDetail.公司)
      searchRadishDetail.行业 = [...setObjIndustry]
      searchRadishDetail.公司 = [...setObjCompany]
      this.radishProjectDetail = searchRadishDetail
      // const fields = [,'已沟通','行业','公司']
    },
    async confirm() {
      if (this.saving) return
      if (!this.updatedBy) {
        this.updatedBy = []
      }
      this.updatedBy.push({ updatedAt: Date.now(), account: app.user.account })
      const dt = {
        不考虑的原因: this.report.不考虑的原因,
        市场情况: this.report.市场情况,
        阿尔法建议: this.report.阿尔法建议,
        人才推荐统计: this.countDetail,
        updatedBy: this.updatedBy,
      }
      this.saving = true
      try {
        await app.service('project').upsertProjectReport({ pid: this.project._id, data: dt })
        this.$message({ type: 'success', message: '保存成功' })
        // this.$set(this.report, '人才推荐统计', dt['人才推荐统计'])
        Object.assign(this.report, dt)
        this.isEditing = false
        // this.dialogVisible = false
        const project = this.project
        const report = this.report
        const radishProjectDetail = this.radishProjectDetail
        let content = `【项目反馈】\n`
        content += `从${dateFormat(project.startTime || project.createdAt, 'yyyy-mm-dd')}项目启动至今，`
        content += `市场上符合要求人选${(report.人才推荐统计 && report.人才推荐统计.已搜寻) ||
          radishProjectDetail.已搜寻}人，`
        content += `已沟通${(report.人才推荐统计 && report.人才推荐统计.已沟通) || radishProjectDetail.已沟通}位；\n\n`
        content += `我们搜索了${(report.人才推荐统计 && report.人才推荐统计.行业) ||
          (radishProjectDetail.行业 || []).join('、')}等行业；共计${(report.人才推荐统计 &&
          report.人才推荐统计.公司 &&
          report.人才推荐统计.公司.split('、').length) ||
          (radishProjectDetail.公司 || []).length}家公司；`
        content += '\n\n'
        content += `人选不考虑的原因：${report.不考虑的原因 || ''}\n\n`
        content += `市场情况及遇到的问题：${report.市场情况 || ''}\n\n`
        content += `我们的建议：${report.阿尔法建议 || ''}`
        project_notify.sendMessage3(this.project._id, '-人才搜寻反馈', '人才搜寻反馈', { 内容: content })
      } catch (e) {
        this.$message({ type: 'error', message: e.message })
      }
      this.saving = false
    },
    async loadProjectReport() {
      try {
        const data = await app.service('project').fetchProjectReport({ pid: this.project._id })
        if (!data) return this.toEdit()
        this.$set(this.report, '不考虑的原因', data['不考虑的原因'])
        this.$set(this.report, '市场情况', data['市场情况'])
        this.$set(this.report, '阿尔法建议', data['阿尔法建议'])
        this.$set(this.report, '人才推荐统计', data['人才推荐统计'])
        if (!(data['阿尔法建议'] && data['市场情况'] && data['不考虑的原因'])) {
          this.toEdit()
        }
        this.updatedBy = data.updatedBy || []
      } catch (e) {
        console.error(e)
      }
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
  },
}
</script>
<style>
.project-search-radish .el-dialog {
  display: flex;
  flex-direction: column;
}
.project-search-radish .el-dialog .el-dialog__body {
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
}
.project-search-radish .el-dialog .el-dialog__body .content {
  overflow: auto;
  flex-grow: 1;
}
</style>
<style scoped>
.bolder {
  font-weight: 700;
}
.header {
  display: flex;
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.keep-all {
  word-break: keep-all;
  white-space: nowrap;
}
.flex-grow {
  flex-grow: 1;
}
.flex {
  display: flex;
}
.half {
  width: 50%;
}
.dialog-common-title {
  font-size: 16px;
  font-weight: 700;
  position: relative;
  text-indent: 20px;
  height: 24px;
  flex: none;
}
.dialog-common-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 5px;
  background-color: #409eff;
  display: block;
}
.project-summary {
  position: relative;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px 20px;
  margin: 0 30px;
  box-shadow: 1px 0px 8px 0 rgba(213, 215, 220, 0.6), 0 2px 4px 0 rgba(201, 203, 211, 0.5);
}
.project-summary-btn {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #409eff;
  cursor: pointer;
  user-select: none;
}
.w196 {
  width: 196px;
}
.w155 {
  text-indent: 8px;
  /* position: relative; */
  font-size: 14px;
  width: 160px;
  flex: none;
  font-weight: 800;
  line-height: 24px;
}
/* .w155:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 16px;
  width: 2px;
  background-color: #409eff;
  display: block;
} */

.word-wrap {
  white-space: pre-wrap;
}
.flex-none {
  flex: none;
}
</style>
